/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ud_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it generate new IDs?`)
};

const es_ud_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Genera nuevos identificadores?`)
};

const de_ud_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werden neue IDs generiert?`)
};

const nl_ud_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereert het nieuwe ID's?`)
};

const fr_ud_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génère-t-il de nouveaux identifiants ?`)
};

const it_ud_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera nuovi ID?`)
};

const pt_br2_ud_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele gera novos IDs?`)
};

const pt_ud_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gera novos IDs?`)
};

const ja_ud_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい ID を生成しますか?`)
};

const zh_ud_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它会生成新的 ID 吗?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ud_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ud_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ud_faq3_q", locale)
	if (locale === "en") return en_ud_faq3_q(inputs)
	if (locale === "es") return es_ud_faq3_q(inputs)
	if (locale === "de") return de_ud_faq3_q(inputs)
	if (locale === "nl") return nl_ud_faq3_q(inputs)
	if (locale === "fr") return fr_ud_faq3_q(inputs)
	if (locale === "it") return it_ud_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_ud_faq3_q(inputs)
	if (locale === "pt") return pt_ud_faq3_q(inputs)
	if (locale === "ja") return ja_ud_faq3_q(inputs)
	return zh_ud_faq3_q(inputs)
};